import { MouseEvent, forwardRef } from 'react';

import {
  IconButton,
  IconButtonProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import { RiCloseLine as CloseIcon } from '@remixicon/react';
import classNames from 'classnames';

import { useDialogContext } from '../DialogComposite/context';

const styles = createStyles({
  root: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  icon: {},
});

export type CloseButtonProps = WithStyles<typeof styles> &
  Omit<IconButtonProps, 'classes'>;

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  (props, ref) => {
    const { className, classes, onClick, ...rest } = props;
    const { onClose } = useDialogContext();
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      onClick?.(e);
      if (e.defaultPrevented) {
        return;
      }
      onClose();
    };

    return (
      <IconButton
        aria-label="close"
        onClick={handleClick}
        ref={ref}
        className={classNames(classes.root, className)}
        data-track-id="button.close"
        data-track-action="dismiss"
        {...rest}
      >
        <CloseIcon className={classes.icon} />
      </IconButton>
    );
  },
);

CloseButton.displayName = 'DialogComposite.CloseButton';

export default withStyles(styles)(CloseButton);
